import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import React from "react";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
	},
	contentRoot: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "center",

		padding: theme.spacing(1),
		height: 166,

		"&:last-child": {
			paddingBottom: theme.spacing(1),
		},
	},
	progress: {},
}));

const DEFAULT_ACCEPT_TYPES = ".png,.jpg,.jpeg,.webp,.pdf,.docx,.doc,.xlsx,.xls,.txt,.eml,.msg";

export const DocumentAddButton = ({
	disabled,
	uploadFile,
	uploading,
	acceptTypes = DEFAULT_ACCEPT_TYPES,
	onBeforeUpload,
	label,
	variant = "text",
	color = "primary",
	fullWidth,
}) => {
	const translate = useTranslate();
	const classes = useStyles();
	const inputRef = React.useRef(null);
	const handleSelectFile = React.useCallback(() => {
		if (onBeforeUpload && !onBeforeUpload()) {
			return;
		}
		inputRef.current.click();
	}, [onBeforeUpload]);

	const handleFileChange = React.useCallback(
		async (e) => {
			uploadFile(e.target.files[0]);
		},
		[uploadFile]
	);

	return (
		<React.Fragment>
			<Button
				variant={variant}
				color={color}
				fullWidth={fullWidth}
				disabled={disabled || uploading}
				startIcon={
					uploading ? (
						<CircularProgress size={16} thickness={5} className={classes.progress} />
					) : (
						<AddIcon />
					)
				}
				onClick={handleSelectFile}
			>
				<input
					ref={inputRef}
					onChange={handleFileChange}
					type="file"
					id="file"
					style={{ display: "none" }}
					accept={acceptTypes}
				/>
				{label || translate("osfc.fields.document.add_document")}
			</Button>
		</React.Fragment>
	);
};
